import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Mui
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

// Routes control
import ProtectedRoutes from "@/router/protectedRoutes";
import PublicRoutes from "@/router/publicRoutes";

// Page
import CheckinPage from "@/page/checkinPage";
import CompareSalesPage from "@/page/compareSalesPage";
import DailyPage from "@/page/dailyPage";
import LoginPage from "@/page/loginPage";
import MainPage from "@/page/mainPage";
import ManningsDashBoardPage from "@/page/manningsDashBoardPage";
import NoticePage from "@/page/noticePage";
import PromoterDashBoardPage from "@/page/promoterDashBoardPage";
import "leaflet/dist/leaflet.css";
import "./App.css";

import DailyDetailPage from "@/page/dailyDetailPage";
import DeliveryOrderDetailPage from "@/page/deliveryOrderDetailPage";
import DeliveryOrderPage from "@/page/deliveryOrderPage";
import NoticeDetailPage from "@/page/noticeDetailPage";
import RefillRequestPage from "@/page/refillRequestPage";

import MergeDeliveryOrder from "@/page/mergeDeliveryOrderPage";

import ProductSalesChartPage from "@/page/chart/productSalesChartPage";
import ProductTrendChartPage from "@/page/chart/productTrendChartPage";
import ShopSalesChartPage from "@/page/chart/shopSalesChartPage";
import ThreeChemBioSalesChartPage from "@/page/chart/threeChemBioSalesChartPage";

import DisscountPerformanceChartPage from "@/page/chart/disscountPerformanceChartPage";
// import RefillRequestDetailPage from "@/page/refillRequestDetailPage";
import CustomerManageDetailPage from "@/page/customerManageDetailPage";
import CustomerManagePage from "@/page/customerManagePage";
import StaffManageDetailPage from "@/page/staffManageDetailPage";
import StaffManagePage from "@/page/staffManagePage";
// import TargetSettingPage from "@/page/targetSettingPage";
import SystemSettingGiftPage from "@/page/systemSettingGiftPage";
import SystemSettingLocationRosterPage from "@/page/systemSettingLocationRosterPage";
import SystemSettingPage from "@/page/systemSettingPage";
import SystemSettingProductPage from "@/page/systemSettingProductPage";
import SystemSettingRosterPage from "@/page/systemSettingRosterPage";
import SystemSettingUserRosterPage from "@/page/systemSettingUserRosterPage";
import SystemSettingWorkPage from "@/page/systemSettingWorkPage";

import CustomerDailyPage from "@/page/customerDailyPage";
import RefundPage from "@/page/refundPage";
import SohManagePage from "@/page/sohManagePage";
//import UploadImagesPage from "@/page/uploadImagesPage";
import ExpensesDetailPage from "@/page/expensesDetailPage";
import ExpensesPage from "@/page/expensesPage";
import LandingFormSettingDetailPage from "@/page/landingFormSettingDetailPage";
import LandingFormSettingPage from "@/page/landingFormSettingPage";
import LandingSettingDetailPage from "@/page/landingSettingDetailPage";
import LandingSettingPage from "@/page/landingSettingPage";
import ManningsLandingResponsePage from "@/page/manningsLandingResponsePage";
import ManningsLandingSettingDetailPage from "@/page/manningsLandingSettingDetailPage";
import ManningsLandingSettingPage from "@/page/manningsLandingSettingPage";
import ProductManagePage from "@/page/productManagePage";
import ProfitAndLossPage from "@/page/profitAndLossPage";
import ProfitAndLossTablePage from "@/page/profitAndLossTablePage";
import StaffManagePermissionPage from "@/page/staffManagePermissionPage";
import StocktakeDetailPage from "@/page/stocktakeDetailPage";
import StocktakePage from "@/page/stocktakePage";

import RoleAccessManagePage from "@/page/roleAccessManagePage";
import WorkLocationManageDetailPage from "@/page/workLocationManageDetailPage";
import WorkLocationManagePage from "@/page/workLocationManagePage";

import { restoreSettings } from "@/features/dataTableSlice";
import { restoreUser } from "@/features/userSlice";
import PharmaGoodCalendarPage from "@/page/pharmagood/calendar";
import PickupLocationSettingPage from "@/page/pharmagood/pickup-locations";
import ReportDownloadPage from "@/page/reportDownloadPage";
import store from "@/store";
import { Provider, useDispatch } from "react-redux";
import CommissionPage from "./page/commissionPage";
import CommissionSettingPage from "./page/commissionSettingPage";
import DenyPage from "./page/denyPage";
import EmployeeBenefitPage from "./page/employeeBenefitPage";
import EmployeeShoppingPage from "./page/employeeShoppingPage";
import ExchangeInvoiceByIdPage from "./page/exchangeInvoiceByIdPage";
import ExchangeInvoicePage from "./page/exchangeInvoicePage";
import GiveAwayManageDetailPage from "./page/giveAwayManageDetailPage";
import GiveAwayManagePage from "./page/giveAwayManagePage";
import ItItemListPage from "./page/itItemListPage";
import NotFoundPage from "./page/notFoundPage";
import OutingPage from "./page/outingPage";
import HiddenOfferCreatePage from "./page/pharmagood/hidden-offers/createPage";
import HiddenOfferEditPage from "./page/pharmagood/hidden-offers/editPage";
import HiddenOfferListPage from "./page/pharmagood/hidden-offers/listPage";
import ProductDiscountPage from "./page/productDiscountPage";
import PromotionTargetCreatePage from "./page/promotionTargetCreatePage";
import PromotionTargetEditPage from "./page/promotionTargetEditPage";
import PromotionTargetPage from "./page/promotionTargetPage";
import PromotionTargetStatisticsPage from "./page/promotionTargetStatisticsPage";
import PushNotificationCreatePage from "./page/pushNotificationCreatePage";
import PushNotificationEditPage from "./page/pushNotificationEditpage";
import PushNotificationPage from "./page/pushNotificationPage";
import QuestionnaireComparisonPage from "./page/questionnaireComparisonPage";
import QuestionnaireConfigPage from "./page/questionnaireConfigPage";
import QuestionnaireCreatePage from "./page/questionnaireCreatePage";
import QuestionnaireReportListPage from "./page/questionnaireReportListPage";
import QuestionnaireUpdatePage from "./page/questionnaireUpdatePage";
import QuestionnaireReportPage from "./page/questionnarieReportPage";
import ReturnInvoiceByIdPage from "./page/returnInvoiceByIdPage";
import ReturnInvoicePage from "./page/returnInvoicePage";
import StockOnHandManageByIdPage from "./page/stockOnHandManageByIdPage";
import StockOnHandManagePage from "./page/stockOnHandManagePage";
import StockOnHandTypeManageByIdPage from "./page/stockOnHandTypeManageByIdPage";
import TransferInvoiceByIdPage from "./page/transferInvoiceByIdPage";
import TransferInvoicePage from "./page/transferInvoicePage";
function App() {
  // States
  const [open, setOpen] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const dispatch = useDispatch();
  const init = async () => {
    await dispatch(restoreUser()).unwrap();

    await dispatch(restoreSettings()).unwrap();
    setIsReady(true);
  };
  React.useEffect(() => {
    init();
  }, []);
  if (isReady) {
    return (
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <BrowserRouter>
          <Routes>
            {/** Protected Routes */}
            <Route path="/" element={<ProtectedRoutes />}>
              {/* <Route path="/" element={<Navigate replace to="dashboard" />} /> */}
              {/** main Routes */}
              <Route
                path="/"
                element={<MainPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="/promoterDashboard"
                element={
                  <PromoterDashBoardPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="/pharmagoodHiddenOffer"
                element={<HiddenOfferListPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="/pharmagoodHiddenOffer/create"
                element={
                  <HiddenOfferCreatePage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="/pharmagoodHiddenOffer/:id"
                element={<HiddenOfferEditPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="/pharmagoodCalendar"
                element={
                  <PharmaGoodCalendarPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="/pharmagoodPickupLocation"
                element={
                  <PickupLocationSettingPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="/manningsDashboard"
                element={
                  <ManningsDashBoardPage open={open} setOpen={setOpen} />
                }
              />
              {/** notice Routes */}
              <Route
                path="notice"
                element={<NoticePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="notice/create"
                element={<NoticeDetailPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="notice/edit/:id"
                element={<NoticeDetailPage open={open} setOpen={setOpen} />}
              />

              {/** daily Routes */}
              <Route
                path="daily"
                element={<DailyPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="daily/detail/:id/:targetDatetime"
                element={<DailyDetailPage open={open} setOpen={setOpen} />}
              />

              {/** refillRequest Routes */}
              <Route
                path="refillRequest"
                element={<RefillRequestPage open={open} setOpen={setOpen} />}
              />

              {/** Chart Routes */}
              <Route
                path="productSalesChart"
                element={
                  <ProductSalesChartPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="shopSalesChart"
                element={<ShopSalesChartPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="threeChemBioSalesChart"
                element={
                  <ThreeChemBioSalesChartPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="productTrendChart"
                element={
                  <ProductTrendChartPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="disscountPerformance"
                element={
                  <DisscountPerformanceChartPage
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              {/** deliveryOrder Routes */}
              <Route
                path="deliveryOrder"
                element={<DeliveryOrderPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="deliveryOrder/:id/:si_number"
                element={
                  <DeliveryOrderDetailPage open={open} setOpen={setOpen} />
                }
              />
              {/** mergeDeliveryOrder Routes */}
              <Route
                path="mergeDeliveryOrder"
                element={<MergeDeliveryOrder open={open} setOpen={setOpen} />}
              />
              {/** productManagement Routes */}
              <Route
                path="productManage"
                element={<ProductManagePage open={open} setOpen={setOpen} />}
              />
              {/** stocktakeManage Routes */}
              <Route
                path="stocktake"
                element={<StocktakePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="stocktake/:id/"
                element={<StocktakeDetailPage open={open} setOpen={setOpen} />}
              />
              {/** workLocation Management Routes */}
              <Route
                path="workLocationManage"
                element={
                  <WorkLocationManagePage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="workLocationManage/edit/:id"
                element={
                  <WorkLocationManageDetailPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="workLocationManage/create"
                element={
                  <WorkLocationManageDetailPage open={open} setOpen={setOpen} />
                }
              />

              {/** giveAway Management Routes */}
              <Route
                path="giveAwayManage"
                element={<GiveAwayManagePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="giveAwayManage/edit/:id"
                element={
                  <GiveAwayManageDetailPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="giveAwayManage/create"
                element={
                  <GiveAwayManageDetailPage open={open} setOpen={setOpen} />
                }
              />
              {/* <Route
            path="refillRequest/:id"
            element={<RefillRequestDetailPage open={open} setOpen={setOpen}  />}
          /> */}

              {/** staffManage Routes */}
              <Route
                path="staffManage"
                element={<StaffManagePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="staffManage/create"
                element={
                  <StaffManageDetailPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="staffManage/edit/:id"
                element={
                  <StaffManageDetailPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="staffManage/permission/:id"
                element={
                  <StaffManagePermissionPage open={open} setOpen={setOpen} />
                }
              />

              {/** Role Access Management Routes */}
              <Route
                path="roleAccessManage"
                element={<RoleAccessManagePage open={open} setOpen={setOpen} />}
              />

              {/** customerManage Routes */}
              <Route
                path="customerManage"
                element={<CustomerManagePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="customerManage/view/:id"
                element={
                  <CustomerManageDetailPage open={open} setOpen={setOpen} />
                }
              />

              {/** targetSetting Routes */}
              {/* <Route path="targetSetting" element={<TargetSettingPage open={open} setOpen={setOpen}  />} /> */}

              {/** systemSetting Routes */}
              <Route
                path="monthlySetting"
                element={<SystemSettingPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="monthlySetting/product/:date"
                element={
                  <SystemSettingProductPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="promotionSetting/"
                element={
                  <SystemSettingProductPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="promotionTarget/"
                element={<PromotionTargetPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="promotionTarget/create"
                element={
                  <PromotionTargetCreatePage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="promotionTarget/:id"
                element={
                  <PromotionTargetEditPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="promotionTargetStatistics"
                element={
                  <PromotionTargetStatisticsPage
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              <Route
                path="reportDownload"
                element={<ReportDownloadPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="roster"
                element={
                  <SystemSettingRosterPage open={open} setOpen={setOpen} />
                }
              />

              <Route
                path="roster/user/:user_id"
                element={
                  <SystemSettingUserRosterPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="roster/location/:location_id"
                element={
                  <SystemSettingLocationRosterPage
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              <Route
                path="checkin"
                element={<CheckinPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="compareSales"
                element={<CompareSalesPage open={open} setOpen={setOpen} />}
              />

              <Route
                path="monthlySetting/work/:date"
                element={
                  <SystemSettingWorkPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="monthlySetting/gift/:date"
                element={
                  <SystemSettingGiftPage open={open} setOpen={setOpen} />
                }
              />
              {/** refunds Routes */}
              <Route
                path="refund"
                element={<RefundPage open={open} setOpen={setOpen} />}
              />

              {/** soh Routes */}
              <Route
                path="sohManage"
                element={<SohManagePage open={open} setOpen={setOpen} />}
              />

              {/** customer daily Routes */}
              <Route
                path="cutomerDaily"
                element={<CustomerDailyPage open={open} setOpen={setOpen} />}
              />

              {/** giveAway Management Routes */}
              <Route
                path="stockOnHandManage"
                element={
                  <StockOnHandManagePage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="stockOnHandManage/:id"
                element={
                  <StockOnHandManageByIdPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="stockOnHandManage/:id/:itemId"
                element={
                  <StockOnHandTypeManageByIdPage
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              <Route
                path="manningsLanding"
                element={
                  <ManningsLandingSettingPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="manningsLanding/:id/response"
                element={
                  <ManningsLandingResponsePage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="manningsLanding/create"
                element={
                  <ManningsLandingSettingDetailPage
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              <Route
                path="manningsLanding/edit/:id"
                element={
                  <ManningsLandingSettingDetailPage
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              {/** landing setting Routes */}
              <Route
                path="landing"
                element={<LandingSettingPage open={open} setOpen={setOpen} />}
              />

              <Route
                path="landing/create"
                element={
                  <LandingSettingDetailPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="landing/edit/:id"
                element={
                  <LandingSettingDetailPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="landingForm"
                element={
                  <LandingFormSettingPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="landingForm/create"
                element={
                  <LandingFormSettingDetailPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="landingForm/edit/:id"
                element={
                  <LandingFormSettingDetailPage open={open} setOpen={setOpen} />
                }
              />
              {/** exchangeInvoice Routes */}
              <Route
                path="exchangeInvoice"
                element={<ExchangeInvoicePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="exchangeInvoice/:id"
                element={
                  <ExchangeInvoiceByIdPage open={open} setOpen={setOpen} />
                }
              />
              {/** returnInvoice Routes */}
              <Route
                path="returnInvoice"
                element={<ReturnInvoicePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="returnInvoice/:id"
                element={
                  <ReturnInvoiceByIdPage open={open} setOpen={setOpen} />
                }
              />
              {/** transferInvoice Routes */}
              <Route
                path="transferInvoice"
                element={<TransferInvoicePage open={open} setOpen={setOpen} />}
              />
              <Route
                path="transferInvoice/:id"
                element={
                  <TransferInvoiceByIdPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="commission"
                element={<CommissionPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="commission/setting/create"
                element={
                  <CommissionSettingPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="commission/setting/:id"
                element={
                  <CommissionSettingPage open={open} setOpen={setOpen} />
                }
              />
              {/** pushNotification Routes */}
              <Route
                path="pushNotification"
                element={<PushNotificationPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="pushNotification/create"
                element={
                  <PushNotificationCreatePage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="pushNotification/edit/:id"
                element={
                  <PushNotificationEditPage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="profitAndLoss"
                element={<ProfitAndLossPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="profitAndLoss/table"
                element={
                  <ProfitAndLossTablePage open={open} setOpen={setOpen} />
                }
              />
              <Route
                path="expenses"
                element={<ExpensesPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="expenses/create"
                element={<ExpensesDetailPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="expenses/edit/:id"
                element={<ExpensesDetailPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="expenses/view/:id"
                element={<ExpensesDetailPage open={open} setOpen={setOpen} />}
              />
              <Route
                path="outing"
                element={<OutingPage open={open} setOpen={setOpen} />}
              />
              {/** productDiscount Routes */}
              <Route
                path="productDiscount"
                element={<ProductDiscountPage open={open} setOpen={setOpen} />}
              />

              {/** employeeBenefit Routes */}
              <Route
                path="employeePurchaseSetting"
                element={<EmployeeBenefitPage open={open} setOpen={setOpen} />}
              />

              {/** employeeShopping Routes */}
              <Route
                path="employeePurchaseRecord"
                element={<EmployeeShoppingPage open={open} setOpen={setOpen} />}
              />
              {/** questionnaireConfig Routes */}
              <Route
                path="questionnaireConfig"
                element={
                  <QuestionnaireConfigPage open={open} setOpen={setOpen} />
                }
              />

              {/** questionnaireCreate Routes */}
              <Route
                path="questionnaireConfig/Create"
                element={
                  <QuestionnaireCreatePage open={open} setOpen={setOpen} />
                }
              />
              {/** questionnaireUpdate Routes */}
              <Route
                path="questionnaireConfig/Update/:questId"
                element={
                  <QuestionnaireUpdatePage open={open} setOpen={setOpen} />
                }
              />
              {/** questionarieReport Routes */}
              <Route
                path="questionnaireReportList"
                element={
                  <QuestionnaireReportListPage
                    Page
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              {/** questionarieReport Routes */}
              <Route
                path="questionnaireReport/:questId"
                element={
                  <QuestionnaireReportPage Page open={open} setOpen={setOpen} />
                }
              />

              {/** questionarieComparison Routes */}
              <Route
                path="questionnaireComparison"
                element={
                  <QuestionnaireComparisonPage
                    Page
                    open={open}
                    setOpen={setOpen}
                  />
                }
              />
              {/** questionarieComparison Routes */}
              <Route
                path="itItemPermission"
                element={<ItItemListPage Page open={open} setOpen={setOpen} />}
              />
              {/** upload image Routes */}
              {/* <Route path="uploadImages" element={<UploadImagesPage open={open} setOpen={setOpen}  />} /> */}
            </Route>

            {/** Public Routes */}
            <Route path="login" element={<PublicRoutes />}>
              <Route path="/login/:slug" element={<LoginPage />} />
              <Route path="/login" element={<LoginPage />} />
            </Route>
            <Route
              path="/permissionDeny"
              element={<DenyPage open={open} setOpen={setOpen} />}
            />
            <Route
              path="*"
              element={<NotFoundPage open={open} setOpen={setOpen} />}
            />
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    );
  }
}
const AppWrapper = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};
export default AppWrapper;
